export default __webpack_public_path__ + "static/media/goshen32.a18aad42.jpg";